module.exports = require("@mui/lab/LocalizationProvider");